/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { SearchFilterExtentRequestVO } from '../model';
// @ts-ignore
import { SearchFilterExtentResultVO } from '../model';
// @ts-ignore
import { SearchFilterTreeVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * SearchFilterControllerApi - axios parameter creator
 * @export
 */
export const SearchFilterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí objekty ve výřezu (`bbox`) odpovídající zafiltrovaným hodnotám (`targets`), spočítané na serveru. Použij, když klient nemůže filtrovat objekty přes mapový engine – např. engine ve výřezu nemá všechny prvky kvůli clusteringu nebo línému načítání.
         * @param {string} topicId 
         * @param {SearchFilterExtentRequestVO} searchFilterExtentRequestVO 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchFilterExtentFeatures: async (topicId: string, searchFilterExtentRequestVO: SearchFilterExtentRequestVO, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getSearchFilterExtentFeatures', 'topicId', topicId)
            // verify required parameter 'searchFilterExtentRequestVO' is not null or undefined
            assertParamExists('getSearchFilterExtentFeatures', 'searchFilterExtentRequestVO', searchFilterExtentRequestVO)
            const localVarPath = `/api/search-filter/{topicId}/extent-features`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchFilterExtentRequestVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí strukturu stromového filtru SearchPanelu pro dané téma. Server vezme číselníky z aktivních vrstev (`layerIds`) a složí z nich strom podle self-relace číselníku (MAPIO_Ciselnik.parentId); koncové uzly stromu jsou aktivní vrstvy, kterých se daná hodnota týká. U každého listu vyplní `target` (ATTRIBUTE = hodnota číselníku na vrstvě, nebo LAYER = celá koncová aktivní vrstva).
         * @param {string} topicId 
         * @param {Array<number>} [layerIds] ID aktivních vrstev, z jejichž číselníků se má filtr složit. Bez nich vrátí prázdný strom.
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchFilterTree: async (topicId: string, layerIds?: Array<number>, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getSearchFilterTree', 'topicId', topicId)
            const localVarPath = `/api/search-filter/{topicId}/tree`
                .replace(`{${"topicId"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerIds) {
                localVarQueryParameter['layerIds'] = layerIds;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchFilterControllerApi - functional programming interface
 * @export
 */
export const SearchFilterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchFilterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí objekty ve výřezu (`bbox`) odpovídající zafiltrovaným hodnotám (`targets`), spočítané na serveru. Použij, když klient nemůže filtrovat objekty přes mapový engine – např. engine ve výřezu nemá všechny prvky kvůli clusteringu nebo línému načítání.
         * @param {string} topicId 
         * @param {SearchFilterExtentRequestVO} searchFilterExtentRequestVO 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchFilterExtentFeatures(topicId: string, searchFilterExtentRequestVO: SearchFilterExtentRequestVO, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFilterExtentResultVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchFilterExtentFeatures(topicId, searchFilterExtentRequestVO, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí strukturu stromového filtru SearchPanelu pro dané téma. Server vezme číselníky z aktivních vrstev (`layerIds`) a složí z nich strom podle self-relace číselníku (MAPIO_Ciselnik.parentId); koncové uzly stromu jsou aktivní vrstvy, kterých se daná hodnota týká. U každého listu vyplní `target` (ATTRIBUTE = hodnota číselníku na vrstvě, nebo LAYER = celá koncová aktivní vrstva).
         * @param {string} topicId 
         * @param {Array<number>} [layerIds] ID aktivních vrstev, z jejichž číselníků se má filtr složit. Bez nich vrátí prázdný strom.
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchFilterTree(topicId: string, layerIds?: Array<number>, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFilterTreeVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchFilterTree(topicId, layerIds, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchFilterControllerApi - factory interface
 * @export
 */
export const SearchFilterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchFilterControllerApiFp(configuration)
    return {
        /**
         * Vrátí objekty ve výřezu (`bbox`) odpovídající zafiltrovaným hodnotám (`targets`), spočítané na serveru. Použij, když klient nemůže filtrovat objekty přes mapový engine – např. engine ve výřezu nemá všechny prvky kvůli clusteringu nebo línému načítání.
         * @param {string} topicId 
         * @param {SearchFilterExtentRequestVO} searchFilterExtentRequestVO 
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchFilterExtentFeatures(topicId: string, searchFilterExtentRequestVO: SearchFilterExtentRequestVO, context?: string, options?: any): AxiosPromise<SearchFilterExtentResultVO> {
            return localVarFp.getSearchFilterExtentFeatures(topicId, searchFilterExtentRequestVO, context, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí strukturu stromového filtru SearchPanelu pro dané téma. Server vezme číselníky z aktivních vrstev (`layerIds`) a složí z nich strom podle self-relace číselníku (MAPIO_Ciselnik.parentId); koncové uzly stromu jsou aktivní vrstvy, kterých se daná hodnota týká. U každého listu vyplní `target` (ATTRIBUTE = hodnota číselníku na vrstvě, nebo LAYER = celá koncová aktivní vrstva).
         * @param {string} topicId 
         * @param {Array<number>} [layerIds] ID aktivních vrstev, z jejichž číselníků se má filtr složit. Bez nich vrátí prázdný strom.
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchFilterTree(topicId: string, layerIds?: Array<number>, context?: string, options?: any): AxiosPromise<SearchFilterTreeVO> {
            return localVarFp.getSearchFilterTree(topicId, layerIds, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchFilterControllerApi - interface
 * @export
 * @interface SearchFilterControllerApi
 */
export interface SearchFilterControllerApiInterface {
    /**
     * Vrátí objekty ve výřezu (`bbox`) odpovídající zafiltrovaným hodnotám (`targets`), spočítané na serveru. Použij, když klient nemůže filtrovat objekty přes mapový engine – např. engine ve výřezu nemá všechny prvky kvůli clusteringu nebo línému načítání.
     * @param {string} topicId 
     * @param {SearchFilterExtentRequestVO} searchFilterExtentRequestVO 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchFilterControllerApiInterface
     */
    getSearchFilterExtentFeatures(topicId: string, searchFilterExtentRequestVO: SearchFilterExtentRequestVO, context?: string, options?: any): AxiosPromise<SearchFilterExtentResultVO>;

    /**
     * Vrátí strukturu stromového filtru SearchPanelu pro dané téma. Server vezme číselníky z aktivních vrstev (`layerIds`) a složí z nich strom podle self-relace číselníku (MAPIO_Ciselnik.parentId); koncové uzly stromu jsou aktivní vrstvy, kterých se daná hodnota týká. U každého listu vyplní `target` (ATTRIBUTE = hodnota číselníku na vrstvě, nebo LAYER = celá koncová aktivní vrstva).
     * @param {string} topicId 
     * @param {Array<number>} [layerIds] ID aktivních vrstev, z jejichž číselníků se má filtr složit. Bez nich vrátí prázdný strom.
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchFilterControllerApiInterface
     */
    getSearchFilterTree(topicId: string, layerIds?: Array<number>, context?: string, options?: any): AxiosPromise<SearchFilterTreeVO>;

}

/**
 * SearchFilterControllerApi - object-oriented interface
 * @export
 * @class SearchFilterControllerApi
 * @extends {BaseAPI}
 */
export class SearchFilterControllerApi extends BaseAPI implements SearchFilterControllerApiInterface {
    /**
     * Vrátí objekty ve výřezu (`bbox`) odpovídající zafiltrovaným hodnotám (`targets`), spočítané na serveru. Použij, když klient nemůže filtrovat objekty přes mapový engine – např. engine ve výřezu nemá všechny prvky kvůli clusteringu nebo línému načítání.
     * @param {string} topicId 
     * @param {SearchFilterExtentRequestVO} searchFilterExtentRequestVO 
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchFilterControllerApi
     */
    public getSearchFilterExtentFeatures(topicId: string, searchFilterExtentRequestVO: SearchFilterExtentRequestVO, context?: string, options?: any) {
        return SearchFilterControllerApiFp(this.configuration).getSearchFilterExtentFeatures(topicId, searchFilterExtentRequestVO, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí strukturu stromového filtru SearchPanelu pro dané téma. Server vezme číselníky z aktivních vrstev (`layerIds`) a složí z nich strom podle self-relace číselníku (MAPIO_Ciselnik.parentId); koncové uzly stromu jsou aktivní vrstvy, kterých se daná hodnota týká. U každého listu vyplní `target` (ATTRIBUTE = hodnota číselníku na vrstvě, nebo LAYER = celá koncová aktivní vrstva).
     * @param {string} topicId 
     * @param {Array<number>} [layerIds] ID aktivních vrstev, z jejichž číselníků se má filtr složit. Bez nich vrátí prázdný strom.
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchFilterControllerApi
     */
    public getSearchFilterTree(topicId: string, layerIds?: Array<number>, context?: string, options?: any) {
        return SearchFilterControllerApiFp(this.configuration).getSearchFilterTree(topicId, layerIds, context, options).then((request) => request(this.axios, this.basePath));
    }
}
